module.exports = __webpack_public_path__ + "img/dashboard.09e8d1e9.svg";